var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-column section",
      staticStyle: { "padding-top": "10px" }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { "padding-top": "5px", height: "100%" },
          attrs: { "label-width": "90px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-radio-group",
                {
                  staticClass: "spacing",
                  attrs: { no: "1" },
                  model: {
                    value: _vm.pageRadio,
                    callback: function($$v) {
                      _vm.pageRadio = $$v
                    },
                    expression: "pageRadio"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      staticStyle: { float: "left" },
                      attrs: { label: "mblNo" }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BlNo")))]
                  ),
                  _c(
                    "el-radio",
                    {
                      staticStyle: { float: "left" },
                      attrs: { label: "jobNo" }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BusinessNo")))]
                  )
                ],
                1
              ),
              _c("el-input", {
                staticClass: "spacing",
                staticStyle: { width: "150px" },
                attrs: { no: "2" },
                model: {
                  value: _vm.inputString,
                  callback: function($$v) {
                    _vm.inputString = $$v
                  },
                  expression: "inputString"
                }
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "3" },
                  on: {
                    click: function($event) {
                      return _vm.queryHandler(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "4" },
                  on: { click: _vm.addCustomInfoHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "5" },
                  on: { click: _vm.editCustomInfoHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "6" },
                  on: { click: _vm.delCustomInfoHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
              )
            ],
            1
          ),
          _c("el-row", { staticStyle: { height: "100%" } }, [
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { "padding-top": "5px", height: "100%" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    "config-module": "9400001",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "grid-params": _vm.gridParams,
                    "check-main-record": false,
                    "deselect-main-record": false
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: _vm.onGridReady
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("cargo-custom-info-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.job,
          title: _vm.cloudFile.title,
          "custom-info": _vm.cloudFile.customInfo,
          "document-type": _vm.cloudFile.documentType,
          lob: _vm.lob,
          "show-all": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.uploadDoneHandler
        }
      }),
      _c("customs-info-dialog", {
        ref: "customsInfoDialog",
        attrs: {
          visible: _vm.editDialog.visible,
          "is-custom-info": true,
          "selected-customs-info": _vm.selectedCustomsInfo,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("customs-info-res-file-history-dialog", {
        attrs: {
          visible: _vm.customsInfoFileDialog.visible,
          "customs-info": _vm.customsInfoFileDialog.customsInfo,
          "customs-info-key": _vm.customsInfoFileDialog.customsInfoKey
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customsInfoFileDialog, "visible", $event)
          }
        }
      }),
      _vm.jobListWindow.visible
        ? _c("job-list-window", {
            attrs: {
              visible: _vm.jobListWindow.visible,
              "job-nos": _vm.jobListWindow.jobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobListWindow, "visible", $event)
              },
              selectJobNoHandler: _vm.selectJobNoHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }